
<template>

  <div class="atividades-solicitacoes ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="5">
                <label for="select-empresa">Empresa</label>  
                <multiselect  id="selecao-empresa-sol"  v-model="value_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false" 
                  @close="loadFiliais(),loadPermissao()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                <label for="select-garagem_sol">Filial</label> 
                <multiselect id="selecao-filial-sol"  v-model="value_filial" required                   
                  :options="filiais" 
                  :multiple="true" 
                   :taggable="true" 
                  @close="loadLote()"  
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data inicial</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_inicial"  placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data final</label>
                  <b-form-datepicker id="dt_sol_final"  required  v-model="dt_final" placeholder="Data do final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

            <b-col cols=1 class="mt-4">
                    
          <b-button size="sm" id="btn-pesquisar" variant="success" block class="mr-2 mt-1 "  @click="loadKpiDia(),loadKpiFilial(),loadKpiStatus(),loadKpiAgendamentoFuncao(),loadKpiFuncionario()">  <!--  , (), loadKpiAgendamentoFuncao(),loadSacSolicitacoes(), -->
              <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Filtrar gráfico
          </b-button>
              </b-col>

          </b-row>
    </b-form>   


            <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="AGENDAMENTOS"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    

                      {{ totalQtd  }}

                      
                  
                  </h2>
                </b-card-text>
              </b-card>   


        </b-card-group> 

    
    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>      
      <div >
        
        <!-- diário  -->
        <b-row>
          <b-col cols="12" class="mt-4" id="grafdia">            
            <apexcharts             
            ref="chartdia"
            height="400" 
            :options="graficoDia" 
            :series="seriesdia"
            >
            </apexcharts>
          </b-col>
        </b-row>

        <!-- acumulado  -->
        <b-row>

          <!-- acumulado  AVALIAÇÃO ESTRELAS -->
          <b-col cols="3">
            <apexcharts
            ref="chartAvaliacao" 
            height="400" 
            :options="graficoAvaliacao" 
            :series="seriesAvaliacao"
            ></apexcharts>
          </b-col>

          <!-- acumulado  FILIAL -->
          <b-col cols="3">
            <apexcharts 
              ref="chart"
              height="400" 
              :options="graficoPizzaFilial"   
              :series ="graficoPizzaFilial.series"     
              
            >
            </apexcharts> 
          </b-col>

          <!-- acumulado  Depto -->
          <b-col cols="3">
            <apexcharts 
            ref="chartdepto"
            height="400" :options="graficoDepto" 
            :series="seriesdepto"></apexcharts>
          </b-col>

          <!-- acumulado  FUNCIONARIO -->
          <b-col cols="3">
            <apexcharts
            ref="chartfuncionario" 
            height="400" 
            :options="graficoFuncioanrio" 
            :series="seriesfuncionario"
            ></apexcharts>
          </b-col>
        </b-row>

      </div>      
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
    


  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'
import { onBeforeUpdate } from 'vue'


export default {  
  name: 'SolicitacaoPainel',

  components: {
    apexcharts: VueApexCharts,
    Multiselect
  },
    computed : { ... mapState (['user'],),
        totalQtd() {
      return this.kpiAvaliacao.reduce((sum, item) => sum + Number(item.qtd), 0);
    },

        totalAgendado() {
      return this.kpiAvaliacao
        .filter(s => s.status === "AGENDADO")
        .reduce((sum, item) => sum + Number(item.qtd), 0);
    },

    } ,



    data: function() {    

        return {

  /* diario */
  graficoDia: {
    chart: {
              id: 'bar-dia',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'AGENDAMENTOS POR PERÍODO',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

    /* diario */
  graficoAvaliacao: {
    chart: {
              id: 'bar-dia',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true,
       /* isFunnel: true,  */
      },
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'STATUS',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  /* filial */  
  graficoPizzaFilial: {
          chart: {
            id: 'pizza-filial',             
            type: 'pie', 
            height: 350,                                      
            foreColor:"black",                         
          },
          labels: [],
          legend: {
            show: true,             
            position: 'bottom',
          },
          title: {
            text: 'Solicitações por filial',
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '22px',
              fontWeight:  'bold',
              color:  '#263238'
            },
          }
  },

  /* Departamento    */
  graficoDepto: {
    chart: {
              id: 'bar-departamento',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        //barWidth: '10%'  // Defina a altura das barras (porcentagem do tamanho total)
        
      }
    },
    xaxis: {  
       labels: {      
      maxWidth: 400  // Define uma largura máxima para os rótulos
    },
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'FUNÇÃO',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


   


/* funcionario    */
  graficoFuncioanrio: {
    chart: {
              id: 'bar-funcionario',
              type: 'bar',
              height: 350,            
            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },     
    title: {
      text: 'Top 10 por funcionários',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


/* dados diario  */
series: [{
        name: 'RA',
        data: [144, 155, 141, 137, 135]
      }, {
        name: 'S.O.S',
        data: [153, 132, 133, 152, 145  ]
      }, {
        name: 'REC NORMAL',
        data: [112, 117, 111, 119, 118 ]
      }, {
      name: 'REC ANORMAL',
      data: [119, 117, 115, 118, 116 ]
    },],

    

/* objetos */

  kpifiliais:[],  
  kpidias:[],  
  kpifuncionario:[] ,
  kpidepto:[],
  kpiAvaliacao:[],
  dt_inicial: '',
  dt_final: '',  
  seriesPizzaFilial:[] ,
  seriesColunaDia:[],  
  seriesdia:[],
  seriesfilial:[],  
  seriesfuncionario:[],
  seriesdepto:[],
  seriesAvaliacao:[],
  empresa:{}, 
  empresas:[],   // [] lista       
  filial:{}, 
  filiais: [],   // [] lista   
  solicitacoes:[],
  value_empresa:[],// [this.empresas],            
  permissoes:[],
  permissao:{},

  mode: 'save',
  carregando: false,
  atualizando: false,   
  value_filial:[],            
  value_status:[],     

        }        
    },

    

    methods: {      

            /// filtros por dia 
      async loadKpiDia() {
            let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                                           
                "id_area": `${[this.permissoes.map(p => p.id_area)]}`,                
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,     
                "psg": `${this.user.psg}`,                                                                                   
            };
          const url = await `${baseApiUrl}/indicadores/agendamento_dia_kpi`
          axios.post(url,corpo)
            .then(res => {              
            this.kpidias = res.data 
            this.updateChartDataDia();               
            })
            .catch(showError)
    },
    
    async updateChartDataDia() {
      this.seriesdia = [{
        name: 'QTD AGENDAMENTO(s)',
        data: this.kpidias.map(item => parseInt(item.dia)),
      }];
      
      this.$refs.chartdia.updateOptions({ 
        xaxis: {
          categories: this.kpidias.map(d => moment(d.dtagendada).format('DD/MM/YYYY'))
        }  
      });
    },

      /// filtros por filial
      async loadKpiFilial() {
          let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,      
                "id_area": `${[this.permissoes.map(p => p.id_area)]}`,                                                                        
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,     
                "psg": `${this.user.psg}`,                                                                                   
          };
          const url = `${baseApiUrl}/indicadores/agendamento_filial_kpi`
          axios.post(url,corpo)
            .then(res => {
              this.kpifiliais = res.data                
              this.updateChartDataFilial();              
            })
            .catch(showError)
      },

      async updateChartDataFilial() {                                                      
            this.graficoPizzaFilial.series = this.kpifiliais.map(item => parseInt(item.qtd));
            this.atualizarLabels()
      },

      async atualizarLabels() {
        this.graficoPizzaFilial.labels = await this.kpifiliais.map(item => item.filial);        
        this.$refs.chart.updateOptions({ labels: this.graficoPizzaFilial.labels });              
      },


      /// filtros por status  08/11/2024
      async loadKpiStatus() {
            let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                                            
                "id_area": `${[this.permissoes.map(p => p.id_area)]}`,               
                "dt_inicial": `${this.dt_inicial}`,                                            
                "dt_final": `${this.dt_final}`,       
                "psg": `${this.user.psg}`,                                                                                 
            };
          const url = await `${baseApiUrl}/indicadores/agendamento_status_kpi`
          axios.post(url,corpo)
            .then(res => {              
            this.kpiAvaliacao = res.data 
            this.updateChartDataAvaliacao();               
            })
            .catch(showError)
    },
    
    async updateChartDataAvaliacao() {
      this.seriesAvaliacao = [{
        name: 'QTD AGENDAMENTO',
        data: this.kpiAvaliacao.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartAvaliacao.updateOptions({ xaxis:{
        categories: this.kpiAvaliacao.map(r => r.status)
      }  });       
    },


    /// filtros por depto tipo solicitação  21/08/2023
      async loadKpiAgendamentoFuncao() {
            let corpo = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,     
                "id_area": `${[this.permissoes.map(p => p.id_area)]}`,               
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,   
                "psg": `${this.user.psg}`,                                                                                     
            };
          const url = await `${baseApiUrl}/indicadores/agendamento_funcao_kpi`
          axios.post(url,corpo)
            .then(res => {              
            this.kpidepto = res.data 
            this.updateKpiSolicitacaoDepto();               
            })
            .catch(showError)
    },
    
    async updateKpiSolicitacaoDepto() {
      this.seriesdepto = [{
        name: 'Qtd AGENDAMENTO',
        data: this.kpidepto.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartdepto.updateOptions({ xaxis:{
        categories: this.kpidepto.map(d => d.solicitante_funcao)
      }  });       
    },





    /// filtros por funcionario  21/08/2023
      async loadKpiFuncionario() {
            let params = {    
                "empresa_id": `${this.value_empresa.map(e => e.id_empresa)}`,                                                            
                "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                                            
                "id_area": `${[this.permissoes.map(p => p.id_area)]}`,               
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,        
                "psg": `${this.user.psg}`,                                                                                
            };
          const url = await `${baseApiUrl}/indicadores/agendamento_solicitante_kpi`
          axios.get(url,{params})
            .then(res => {              
            this.kpifuncionario = res.data 
            this.updateChartDataFuncionario();               
            })
            .catch(showError)
    },
    
    async updateChartDataFuncionario() {
      this.seriesfuncionario = [{
        name: 'Qtd solicitações',
        data: this.kpifuncionario.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartfuncionario.updateOptions({ xaxis:{
        categories: this.kpifuncionario.map(r => r.solicitante_re)
      }  });       
    },



        loadEmpresas() {
            let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,    
                  "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                   
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.get(url,{params}).then(res => {
            this.empresas = res.data.map(empresa => {              
              return { id_empresa: empresa.id_empresa, empresa: empresa.nomeempresarial }
            })
          })
        },  
      
        loadFiliais() {
            let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,  
                "id_empresa": `${this.user.id_empresa}`,   
                "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                            
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.get(url,{params}).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
        },
        
        loadPermissao() {
            let params = {    
                "id_grupo": `${this.user.id_grupo}`,                                            
                "id_empresa": `${this.user.id_empresa}`,       
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                              
            };

          const url = `${baseApiUrl}/sac/permissao`
          axios.get(url,{params}).then(res => {
            this.permissoes = res.data.map(permissao => {              
               return { ... permissao, id_area: permissao.id_area}
            })
            //this.loadSacSolicitacoes()
            
          })
        },

        loadSacSolicitacoes() {
            let corpo = {                    
                "id_empresa": `${this.value_empresa.map(e => e.id_empresa)}`,                     
                "id_filial": `${[this.value_filial.map(a => a.id_filial_erp)]}`, 
                "id_area": `${[this.permissoes.map(p => p.id_area)]}`,                               
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,      
                                                                      
            }; 
            const url = `${baseApiUrl}/indicadores/solicitacao`            
            axios.post(url,corpo)
                  .then(res => {              
                  this.solicitacoes = res.data                      
                  })
                  .catch(showError)
                            
        },



    },

    created(){
      this.loadPermissao()           
    },



    mounted(){
        this.loadEmpresas()                                        
        this.loadGaragens()     
    },
   
  



}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>